/*****/ document.addEventListener("DOMContentLoaded", function () {
    function formatPrices() {
        document.querySelectorAll("#_rsi-cod-form-modal .money").forEach(function (el) {
            let priceText = el.innerText.replace(/[^\d]/g, ""); 
            if (priceText) {
                let formattedPrice = Number(priceText).toLocaleString("en-US").replace(/,/g, ".");
                el.innerText = formattedPrice.replace(/\./g, ",");
            }
        });
    }

    // Check if modal is open every second and format prices
    setInterval(function () {
        let modal = document.querySelector("#_rsi-cod-form-modal");
        if (modal && modal.style.display !== "none") {
            formatPrices();
        }
    }, 1000); // Runs every second
});



document.addEventListener('DOMContentLoaded', () => {
    const menu = document.getElementById('Details-menu-drawer-container');
    const button = document.querySelector('.sticky-buy-bar');
    
    if (menu && button) {
        // Store the original display value (defaults to computed style if not set)
        const originalDisplay = window.getComputedStyle(button).display;
        
        new MutationObserver((mutations) => {
            if (menu.classList.contains('menu-opening')) {
                // Hide the button if menu is opening
                button.style.display = 'none';
            } else {
                // Restore the original display value when menu closes
                button.style.display = 'flex';
            }
        }).observe(menu, { attributes: true, attributeFilter: ['class'] });
    }
});


/***

///Tidio Contact Us Button
document.addEventListener('DOMContentLoaded', function() {
  // First check if Tidio iframe exists
  const checkForTidio = setInterval(function() {
    const iframe = document.querySelector('#tidio-chat-iframe');
    const chatTrigger = document.getElementById('HeaderDrawer-contact-us');
    
    if (iframe) {
      clearInterval(checkForTidio); // Stop checking once found
      
      // Show the contact us button
      if (chatTrigger) {
        chatTrigger.style.display = 'block'; // or 'inline' or '' depending on your layout
        
        // Add click handler
        chatTrigger.addEventListener('click', function(e) {
          e.preventDefault();
          // Try Tidio's official method first
          if (typeof tidioChatApi !== 'undefined') {
            tidioChatApi.open();
          } 
          // Fallback to iframe click
          else {
            iframe.click();
          }
        });
      }
    } else {
      // Hide the contact us button if iframe not found
      if (chatTrigger) {
        chatTrigger.style.display = 'none';
      }
    }
  }, 500); // Check every 500ms

  // Optional: Add timeout to stop checking after a while
  setTimeout(function() {
    clearInterval(checkForTidio);
  }, 10000); // Stop checking after 10 seconds
});

****/




//Last week Sales


document.addEventListener('DOMContentLoaded', function() {
  // Get the product metafield value (assuming it's available in the global theme object)
  const productData = window.productData || {};
  const lastWeekSales = productData.metafields?.custom?.last_week_sales?.value;
  
  // Get the product form buttons element
  const productFormButtons = document.querySelector('.product-form__buttons');
  
  if (lastWeekSales && productFormButtons) {
    // Create the message element
    const salesMessage = document.createElement('div');
    salesMessage.className = 'last-week-sales-message';
    salesMessage.textContent = `Over ${lastWeekSales} sold in the last week`;
    salesMessage.style.marginBottom = '10px';
    salesMessage.style.textAlign = 'center';
    salesMessage.style.fontSize = '0.9em';
    salesMessage.style.color = '#555';
    
    // Insert the message before the product form buttons
    productFormButtons.parentNode.insertBefore(salesMessage, productFormButtons);
  }
});



/**
//Floating variant button

document.addEventListener("DOMContentLoaded", () => {
    if (window.innerWidth > 749) return;

    const variantSelects = document.querySelector("variant-selects");
    // target the slider wrapper/viewport, NOT the individual slide
    const sliderContainer = document.querySelector(".product__media-wrapper") 
                          || document.querySelector("slider-component");

    if (variantSelects && sliderContainer) {
        // make sure the container can host an absolutely-positioned child
        sliderContainer.style.position = "relative";
        sliderContainer.appendChild(variantSelects);
    }
});  ***/







//Block upcountry orders
/**
 * Blocks COD form submission when the address field contains a
 * restricted region name (case-insensitive, whole-word match).
 * Add new region names to BLOCKED_REGIONS as needed.
 *
 * Paste this inside a <script> tag in theme.liquid (before </body>),
 * or as a separate asset loaded on storefront pages.
 */
(function () {
  var BLOCKED_REGIONS = ['mombasa', 'kwale', 'kilifi', 'tana river', 'lamu', 'taita-taveta', 'garissa', 'wajir', 'mandera',
     'marsabit', 'isiolo', 'meru', 'tharaka-nithi', 'embu', 'kitui', 'machakos', 'makueni', 'nyandarua', 'nyeri', 'kirinyaga', 
     'muranga', 'kiambu', 'turkana', 'west pokot', 'samburu', 'trans nzoia', 'uasin gishu', 'elgeyo-marakwet', 'nandi', 
     'baringo', 'laikipia', 'nakuru', 'narok', 'kericho', 'bomet', 'kakamega', 'vihiga', 'bungoma', 'busia', 
     'siaya', 'kisumu', 'homa bay', 'migori', 'kisii', 'nyamira'
  ];

  // Only these towns get the "street name" exemption below — because
  // Kampala actually has streets named after them (Jinja Road, Gulu Close,
  // etc). Every other name in BLOCKED_REGIONS is blocked outright, no
  // matter what word follows it.
  var SUFFIX_EXEMPT_REGIONS = ['nakuru', 'mombasa', 'thika'];

  // If one of the towns above is immediately followed by one of these
  // words, it's almost certainly a street name rather than the actual
  // town — so that occurrence is let through.
  var ALLOWED_SUFFIXES = ['rd', 'road', 'close', 'st', 'street', 'ave', 'avenue', 'lane', 'way', 'crescent', 'drive', 'park'];

  function containsBlockedRegion(value) {
    var lower = (value || '').toLowerCase();
    return BLOCKED_REGIONS.some(function (region) {
      var isExemptable = SUFFIX_EXEMPT_REGIONS.indexOf(region) !== -1;

      if (!isExemptable) {
        // No exemption applies to this town - a plain match is enough.
        return new RegExp('\\b' + region + '\\b', 'i').test(lower);
      }

      // Exemptable town: capture the word immediately following each
      // match and only block if that occurrence isn't a street suffix.
      var pattern = new RegExp('\\b' + region + '\\b\\s*([a-z]*)', 'gi');
      var match;
      while ((match = pattern.exec(lower)) !== null) {
        var nextWord = (match[1] || '').trim();
        if (ALLOWED_SUFFIXES.indexOf(nextWord) === -1) {
          return true; // this occurrence isn't followed by an allowed suffix — still block
        }
        // else: this occurrence is exempt — keep scanning for other occurrences
      }
      return false;
    });
  }

  function getWrapper(input) {
    return input.closest('._rsi-modal-fields-item') || input.parentElement;
  }

  function showAddressError(input) {
    clearAddressError(input);
    var errorEl = document.createElement('div');
    errorEl.className = '_rsi-address-region-error';
    errorEl.style.color = '#d92d20';
    errorEl.style.fontSize = '0.85em';
    errorEl.style.marginTop = '4px';
    errorEl.textContent = "Payment on delivery isn't supported in your region! It will have to be a prepayed order if its to be sent over to you.";
    input.insertAdjacentElement('afterend', errorEl);
    input.style.border = '1px solid #d92d20';
  }

  function clearAddressError(input) {
    var wrapper = getWrapper(input);
    var existing = wrapper.querySelector('._rsi-address-region-error');
    if (existing) existing.remove();
    input.style.border = '';
  }

  // Capture phase so this runs BEFORE the Realsit app's own submit
  // handler and can stop the order from going through.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.id !== '_rsi-cod-form-modal-form') return;

      var addressInput = form.querySelector('#_rsi-field-address');
      if (!addressInput) return;

      if (containsBlockedRegion(addressInput.value)) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showAddressError(addressInput);
        addressInput.focus();
        return false;
      } else {
        clearAddressError(addressInput);
      }
    },
    true
  );

  // Clear the error live as the customer edits the field.
  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === '_rsi-field-address') {
      if (!containsBlockedRegion(e.target.value)) {
        clearAddressError(e.target);
      }
    }
  });
})();




/***/



//Country Prices

(function () {
  function formatUGX(value) {
    return new Intl.NumberFormat("en-UG", {
      maximumFractionDigits: 0
    }).format(value);
  }

  function setPrice(element, value) {
    const formatted = formatUGX(value);
    const expected = `UGX ${formatted}`;

    if (element.textContent.trim() === expected) return;

    element.innerHTML =
      `UGX <span class="money">${formatted}</span>`;
  }

  function updateCountryPrices() {
    if (window.storeCountry !== "UG") return;

    document.querySelectorAll(
      ".price[data-ug-price], .product-option[data-ug-price]"
    ).forEach(function (root) {
      const price = Number(root.dataset.ugPrice);
      const compare = Number(root.dataset.ugComparePrice);

      if (!Number.isFinite(price) || price <= 0) return;

      // Side cart price
      if (root.classList.contains("product-option")) {
        setPrice(root, price);
        return;
      }

      // Product pages and product cards
      const regular = root.querySelector(
        ".price__regular .price-item--regular"
      );

      const sale = root.querySelector(
        ".price__sale .price-item--sale"
      );

      const compareElement = root.querySelector(
        ".price__sale s.price-item--regular"
      );

      const hasSale =
        Number.isFinite(compare) && compare > price;

      root.classList.toggle("price--on-sale", hasSale);

      if (regular) setPrice(regular, price);
      if (sale) setPrice(sale, price);

      if (compareElement && hasSale) {
        setPrice(compareElement, compare);
      }

      const badge = root.querySelector(".price__badge-sale");

      if (badge) {
        const discount = hasSale
          ? Math.round(((compare - price) / compare) * 100)
          : 0;

        const badgeText = `${discount}% OFF`;

        if (hasSale) {
          if (badge.textContent.trim() !== badgeText) {
            badge.textContent = badgeText;
          }
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      }
    });
  }

  function start() {
    updateCountryPrices();

    const observer = new MutationObserver(function () {
      updateCountryPrices();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, {
      once: true
    });
  } else {
    start();
  }
})();






//Realsit COD



(function () {
  function formatUGX(value) {
    return new Intl.NumberFormat("en-UG", {
      maximumFractionDigits: 0
    }).format(value);
  }

  function setTextPrice(element, value) {
    const expected = `UGX ${formatUGX(value)}`;

    if (element.textContent.trim() === expected) return;

    element.innerHTML =
      `UGX <span class="money">${formatUGX(value)}</span>`;
  }


  function collectCartUgandaPrices() {
    if (!window.ugPricesByVariant) {
      window.ugPricesByVariant = {};
    }

    document
      .querySelectorAll(".cart-item[data-variant-id]")
      .forEach(function (item) {
        const variantId = item.dataset.variantId;
        const price = Number(item.dataset.ugPrice);
        const compareAtPrice = Number(item.dataset.ugComparePrice);

        if (
          !variantId ||
          !Number.isFinite(price) ||
          price <= 0
        ) {
          return;
        }

        window.ugPricesByVariant[String(variantId)] = {
          ...window.ugPricesByVariant[String(variantId)],
          price: price,
          compareAtPrice:
            Number.isFinite(compareAtPrice) && compareAtPrice > 0
              ? compareAtPrice
              : null
        };
      });
  }

  function updateRealistCOD() {
    if (window.storeCountry !== "UG") return;

    // Refresh the mapping before processing the COD modal.
    collectCartUgandaPrices();

    const modal = document.getElementById("_rsi-cod-form-modal");
    if (!modal) return;

    const lines = Array.from(
      modal.querySelectorAll("._rsi-modal-line-item")
    );

    if (!lines.length) return;

    const mappedLines = [];

    for (const line of lines) {
      const variantInput = line.querySelector(
        'input[name^="item_variant_id"]'
      );

      const quantityInput = line.querySelector(
        'input[name^="item_quantity"]'
      );

      const variantId = variantInput?.value;
      const data = window.ugPricesByVariant?.[String(variantId)];
      const price = Number(data?.price);

      // Do not convert only some items if another item is missing
      // its Uganda price. That would create a mixed-currency display.
      if (!data || !Number.isFinite(price) || price <= 0) {
        return;
      }

      const quantity = Math.max(
        1,
        Number(quantityInput?.value || 1)
      );

      mappedLines.push({
        line,
        price,
        quantity
      });
    }

    // Update each product's displayed unit price.
    mappedLines.forEach(function ({ line, price }) {
      const priceElement = line.querySelector(
        "._rsi-modal-line-item-final-price"
      );

      if (priceElement) {
        setTextPrice(priceElement, price);
      }
    });

    // Calculate the product subtotal in UGX.
    const subtotal = mappedLines.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0
    );

    const shipping = modal.querySelector(
      '[data-checkout-line="shipping"] ._rsi-modal-checkout-line-value'
    );

    const shippingIsFree =
      shipping &&
      shipping.textContent.trim().toLowerCase() === "free";

    // Preserve the existing safeguards for discounts and shipping.
    const discountLines = modal.querySelectorAll(
      '[data-checkout-line="discount"]'
    );

    const hasDiscount = Array.from(discountLines).some(
      element => element.textContent.trim() !== ""
    );

    if (shippingIsFree && !hasDiscount) {
      const subtotalElement = modal.querySelector(
        '[data-checkout-line="subtotal"] ._rsi-modal-checkout-line-value'
      );

      const totalElement = modal.querySelector(
        '[data-checkout-line="total"] ._rsi-modal-checkout-line-value'
      );

      const buttonTotal = modal.querySelector(
        ".rsi-cod-form-submit-total-value"
      );

      if (subtotalElement) {
        setTextPrice(subtotalElement, subtotal);
      }

      if (totalElement) {
        setTextPrice(totalElement, subtotal);
      }

      if (buttonTotal) {
        setTextPrice(buttonTotal, subtotal);
      }
    }
  }

  function start() {
    updateRealistCOD();

    // The cart drawer and COD modal may update dynamically.
    // Debounce observer callbacks to avoid repeated processing.
    let updateScheduled = false;

    const observer = new MutationObserver(function () {
      if (updateScheduled) return;

      updateScheduled = true;

      Promise.resolve().then(function () {
        updateScheduled = false;
        updateRealistCOD();
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: [
        "data-variant-id",
        "data-ug-price",
        "data-ug-compare-price",
        "value"
      ]
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, {
      once: true
    });
  } else {
    start();
  }
})();



//Hide form and upsell

(function () {
  // Run only for the Uganda market
  if (window.storeCountry !== 'UG') return;

  function hideUgandaCodElements() {
    // Hide the entire Email field
    

    // Hide ALL upsell offer blocks, regardless of the product
    document.querySelectorAll('._rsi-tick-ups-offer').forEach(
      function (upsell) {
        upsell.style.setProperty(
          'display',
          'none',
          'important'
        );
      }
    );
  }

  function initializeUgandaCodHiding() {
    hideUgandaCodElements();

    // Handle COD elements loaded or re-rendered by the app
    const observer = new MutationObserver(function () {
      hideUgandaCodElements();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.body) {
    initializeUgandaCodHiding();
  } else {
    document.addEventListener(
      'DOMContentLoaded',
      initializeUgandaCodHiding,
      { once: true }
    );
  }
})();




//Flag
  document.addEventListener("DOMContentLoaded", function () {
    if (window.storeCountry !== "UG") return;

    document.querySelectorAll(".pxft-country-flag").forEach(function (flag) {
      flag.src =
        "https://cdn.shopify.com/s/files/1/0924/7925/8931/files/Flag_of_Uganda.svg?v=1738589906";
    });
  });


   





